import { Interpolation, Theme } from '@emotion/react';
import { ContainedIcon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';

export const gradientAnimationStyles = (color1?: string, color2?: string) => {
  const firstColor = color1 || theme.colors.primary10;
  const secondColor = color2 || theme.colors.secondary.seaweed5;
  const gradientColors = [firstColor, secondColor, firstColor, secondColor];

  // Create unique keyframe name based on colors to avoid conflicts
  const keyframeName = `gradient-${firstColor.replace(/[^a-zA-Z0-9]/g, '')}-${secondColor.replace(
    /[^a-zA-Z0-9]/g,
    ''
  )}`;

  return {
    background: `linear-gradient(-90deg, ${gradientColors.join(', ')})`,
    backgroundSize: '400% 400%',
    animation: `${keyframeName} 5s ease infinite`,

    [`@keyframes ${keyframeName}`]: {
      '0%': {
        backgroundPosition: '0% 50%',
      },
      '50%': {
        backgroundPosition: '100% 50%',
      },
      '100%': {
        backgroundPosition: '0% 50%',
      },
    },
  };
};

export const AiContainedIcon = ({
  as = 'div',
  iconName = 'aiweave-assistant',
  containerStyles,
  size = 20,
  gradientColor1,
  gradientColor2,
  className,
}: {
  as?: React.ElementType;
  iconName?: IconName;
  containerStyles?: Interpolation<Theme>;
  size?: number;
  gradientColor1?: string;
  gradientColor2?: string;
  className?: string;
}) => {
  return (
    <ContainedIcon
      as={as}
      iconName={iconName}
      className={className}
      css={[
        {
          padding: 2,
          borderRadius: 'var(--fabric-radius-sm)',
          ...gradientAnimationStyles(gradientColor1, gradientColor2),

          '&:hover:not(:disabled), &:focus:not(:disabled)': {
            ...gradientAnimationStyles(gradientColor1, gradientColor2),
          },
        },
        containerStyles,
      ]}
      size={size}
    />
  );
};
